import { showErrorMessage } from '../../../../components/message-boxes/ErrorMessage';
import { TpExpressionContext, evalExpression } from '../../../../components/safeExpressions';
import { TpDashboardActionContext, TpDbActionStepDefinition as TpDbActionStepTypeDefinition } from '../interfaces';
import {
  addFunctionsToExpressionContext,
  defaultExpressionFunctionsList,
  getExpressionFunctionsDescription,
} from './dbActionStepTypeCalculateVariable';

function getJsonSchema(): any {
  return {
    type: 'object',
    title: 'Error',
    description: 'Reports an error and aborts the action if a condition was met.',
    properties: {
      type: { type: 'string', const: 'Error' },
      expression: {
        type: 'string',
        description: `Expression to be evaluated. The conditional steps will only be executed if this evalues to true.
Special functions: ${getExpressionFunctionsDescription(defaultExpressionFunctionsList)}.`,
      },
      message: {
        type: 'string',
        description: `Error message to be shown to the user.`,
      },
    },
    required: ['type', 'expression', 'error'],
  };
}

function execute(ctx: TpDashboardActionContext, step: any, onCompleted: () => void) {
  const parameters: { [id: string]: any } = {};
  for (const variabName in ctx.variables) parameters['$' + variabName] = ctx.variables[variabName].content;
  const expr: TpExpressionContext = {
    expressionString: step.expression,
    parameters,
  };
  addFunctionsToExpressionContext(expr, defaultExpressionFunctionsList);
  const result = evalExpression(expr);
  if (result) {
    showErrorMessage(step.message);
  } else {
    onCompleted();
  }
}

const dbActionStepTypeError: TpDbActionStepTypeDefinition = {
  stepType: 'Error',
  execute,
  getJsonSchema,
};

export default dbActionStepTypeError;
